var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.04,
    y1: 0.063,
    x2: 0.979,
    y2: 0.941,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#d37c51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#903163"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(-834 -144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_9532",
    "data-name": "Path 9532",
    transform: "translate(834 144)",
    fill: "none",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62,0A62,62,0,1,1,0,62,62,62,0,0,1,62,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 1 C 53.76461791992188 1 45.77610015869141 2.612686157226562 38.25634765625 5.793266296386719 C 34.64206695556641 7.321983337402344 31.15601348876953 9.214164733886719 27.89501953125 11.41725158691406 C 24.66474914550781 13.59958648681641 21.62711334228516 16.10586547851562 18.86648559570312 18.86648559570312 C 16.10586547851562 21.62711334228516 13.59958648681641 24.66474914550781 11.41725158691406 27.89501953125 C 9.214164733886719 31.15601348876953 7.321983337402344 34.64206695556641 5.793266296386719 38.25634765625 C 2.612686157226562 45.77610015869141 1 53.76461791992188 1 62 C 1 70.23538208007812 2.612686157226562 78.22389984130859 5.793266296386719 85.74365234375 C 7.321983337402344 89.35793304443359 9.214164733886719 92.84397888183594 11.41725158691406 96.10498046875 C 13.59958648681641 99.33525085449219 16.10586547851562 102.3728790283203 18.86648559570312 105.1335144042969 C 21.62711334228516 107.8941345214844 24.66474914550781 110.4004135131836 27.89501953125 112.5827484130859 C 31.15601348876953 114.7858352661133 34.64206695556641 116.6780166625977 38.25634765625 118.2067337036133 C 45.77610015869141 121.3873138427734 53.76461791992188 123 62 123 C 70.23538208007812 123 78.22389984130859 121.3873138427734 85.74365234375 118.2067337036133 C 89.35793304443359 116.6780166625977 92.84397888183594 114.7858352661133 96.10498046875 112.5827484130859 C 99.33525085449219 110.4004135131836 102.3728790283203 107.8941345214844 105.1335144042969 105.1335144042969 C 107.8941345214844 102.3728790283203 110.4004135131836 99.33525085449219 112.5827484130859 96.10498046875 C 114.7858352661133 92.84397888183594 116.6780166625977 89.35793304443359 118.2067337036133 85.74365234375 C 121.3873138427734 78.22389984130859 123 70.23538208007812 123 62 C 123 53.76461791992188 121.3873138427734 45.77610015869141 118.2067337036133 38.25634765625 C 116.6780166625977 34.64206695556641 114.7858352661133 31.15601348876953 112.5827484130859 27.89501953125 C 110.4004135131836 24.66474914550781 107.8941345214844 21.62711334228516 105.1335144042969 18.86648559570312 C 102.3728790283203 16.10586547851562 99.33525085449219 13.59958648681641 96.10498046875 11.41725158691406 C 92.84397888183594 9.214164733886719 89.35793304443359 7.321983337402344 85.74365234375 5.793266296386719 C 78.22389984130859 2.612686157226562 70.23538208007812 1 62 1 M 62 0 C 96.24165344238281 0 124 27.75834655761719 124 62 C 124 96.24165344238281 96.24165344238281 124 62 124 C 27.75834655761719 124 0 96.24165344238281 0 62 C 0 27.75834655761719 27.75834655761719 0 62 0 Z",
    stroke: "none",
    fill: "#f26c21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(845 154)",
    fill: "none",
    stroke: "#f26c21",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(856 165)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5490",
    "data-name": "Group 5490",
    transform: "translate(848.696 184.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5481",
    "data-name": "Group 5481",
    transform: "translate(31 6.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5480",
    "data-name": "Group 5480",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10309",
    "data-name": "Path 10309",
    d: "M62.776,107.377a3.259,3.259,0,0,0-2.428-5.435H54.019a21.076,21.076,0,0,0,.894-5.508V95.348A4.353,4.353,0,0,0,50.565,91H49.478a1.087,1.087,0,0,0-1.054.823l-.592,2.369c-.83,3.317-3.464,6.978-6.19,7.643a3.265,3.265,0,0,0-3.033-2.067H32.087A1.087,1.087,0,0,0,31,100.855V120.42a1.087,1.087,0,0,0,1.087,1.087h6.522a3.264,3.264,0,0,0,2.943-1.859l3.735,1.245a11.93,11.93,0,0,0,3.781.614h9.106a3.262,3.262,0,0,0,3.032-4.462,3.259,3.259,0,0,0,1.57-5.32,3.254,3.254,0,0,0,0-4.348ZM39.7,118.247a1.088,1.088,0,0,1-1.087,1.087H33.174V101.942h5.435a1.088,1.088,0,0,1,1.087,1.087Zm18.478-9.783h2.174a1.087,1.087,0,0,1,0,2.174H58.174a1.087,1.087,0,0,0,0,2.174h2.174a1.087,1.087,0,1,1,0,2.174H58.174a1.087,1.087,0,1,0,0,2.174,1.087,1.087,0,1,1,0,2.174H49.068a9.762,9.762,0,0,1-3.094-.5l-4.1-1.368v-13.45a8.759,8.759,0,0,0,4.88-3.171,15.86,15.86,0,0,0,3.191-6.122l.386-1.546h.238a2.177,2.177,0,0,1,2.174,2.174v1.086a17.2,17.2,0,0,1-1.041,5.508h-2.22a1.087,1.087,0,0,0,0,2.174h10.87a1.087,1.087,0,0,1,0,2.174H58.174a1.087,1.087,0,0,0,0,2.174Z",
    transform: "translate(-31 -91)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5483",
    "data-name": "Group 5483",
    transform: "translate(35.269 30.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5482",
    "data-name": "Group 5482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2871",
    "data-name": "Ellipse 2871",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(0.035 -0.036)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5485",
    "data-name": "Group 5485",
    transform: "translate(50.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5484",
    "data-name": "Group 5484"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10310",
    "data-name": "Path 10310",
    d: "M302.087,0A1.087,1.087,0,0,0,301,1.087V3.333a1.087,1.087,0,1,0,2.174,0V1.087A1.087,1.087,0,0,0,302.087,0Z",
    transform: "translate(-301)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5487",
    "data-name": "Group 5487",
    transform: "translate(43.648 2.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10311",
    "data-name": "Path 10311",
    d: "M208.933,42.4,207.4,40.86a1.087,1.087,0,1,0-1.537,1.537l1.537,1.537a1.087,1.087,0,0,0,1.537-1.537Z",
    transform: "translate(-205.54 -40.542)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5489",
    "data-name": "Group 5489",
    transform: "translate(55.946 2.938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10312",
    "data-name": "Path 10312",
    d: "M378.639,40.86a1.087,1.087,0,0,0-1.537,0L375.565,42.4a1.087,1.087,0,0,0,1.537,1.537l1.537-1.537A1.087,1.087,0,0,0,378.639,40.86Z",
    transform: "translate(-375.247 -40.542)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.aa1255f3d6bb13820ed5fc51d7762ef2.svg";
export { ForwardRef as ReactComponent };